function ContactController(){
	this.className			= "ContactController";
	this.view				= false; //"example";
	this.glob				= ["/contact**", "/contact?*"];
    this.log                = false;
}

ContactController.inheritsFrom( PageController );
ContactController.prototype.setup = function(onComplete){
	if(this.isSetup) return;
	this.$body				= $('body');
	this.isSetup 			= true;
	this.contactDelay 		= 500;
	this.intervalScanner	= 100;
};

ContactController.prototype.on = function(){
	this.contactFormElement = $(".js-contact-form");
	this.signupForm = new SignupForm();
	this.contactPageForm = new ContactPageForm();
	this.checkforContactForm();
};

ContactController.prototype.off = function(){
	this.signupForm.destroy();
	this.contactPageForm.destroy();
	this.contactFormElement.unbind('keydown');
};

ContactController.prototype.swap = function(){
	if(!this.isSetup) this.setup();
	this.$page  = this.$body.find('.js-page');

	this.$map = document.getElementById("contact-map");

	if(this.$map){
		window.includeGoogleMapsCallback = () => {
			this.initMap();

			//add map marker
			let eccordLatLng = new google.maps.LatLng(51.49294810278925, -0.15628867543799607);
            let eccordInfo = "56 Sloane Square, London, SW1X 8AX";
            let marker = new google.maps.Marker({
                position: eccordLatLng,
                title: eccordInfo,
                icon: 'https://eccord.com/assets/icons/location_pin_36.svg'
            });
			marker.setMap(this.map);

		};

		//loading for google maps
		(function(d, t) {
		   var g = d.createElement(t);
		   g.src = "//maps.googleapis.com/maps/api/js?key=AIzaSyByr7RunoopFRN6iE9A5ditx5iQyuVwig8&callback=includeGoogleMapsCallback";
		   document.body.appendChild(g);
		})(document, 'script');
	}
};

ContactController.prototype.initMap = function(){
	this.map = new google.maps.Map(this.$map, {
      center: { lat: 51.49294810278925, lng: -0.15628867543799607 },
      zoom: 16,
      mapTypeControl: false,
	  streetViewControl: false,
	  fullscreenControl: false,
      styles:[{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","stylers":[{"visibility":"on"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}]
    });
}


ContactController.prototype.checkforContactForm = function() {
	var checkFormElementsExist = setInterval((e) => {
	    if (this.contactFormElement.find('input').length) {
	    	clearInterval(checkFormElementsExist);
	    	this.contactFormSetup();
	    }
	}, this.intervalScanner);	
};

ContactController.prototype.validateEmail = function(emailAddress) {
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (reg.test(emailAddress) == false) {
        	return false;
        } else {
        	return true;
        }
}

ContactController.prototype.contactFormSetup = function() {
	//controls the hiding/showing fields in the contact page contact form

	var nameField 		= this.contactFormElement.find('input[name=name]');
	var emailField 		= this.contactFormElement.find('input[name=email]'); 
	var telephoneField 	= this.contactFormElement.find('input[name=telephone]'); 
	var submitButton 	= this.contactFormElement.find('.input-submit')

	nameField.off('input').on('input', (e) => {
		//shows other form fields once name has been populated
		this.contactFormElement.find('.cp-email').delay(this.contactDelay).fadeIn(this.contactDelay);
		this.contactFormElement.find('.cp-enquiry').delay(this.contactDelay).fadeIn(this.contactDelay);
		this.contactFormElement.find('.cp-telephone').delay(this.contactDelay).fadeIn(this.contactDelay);
		this.contactFormElement.find('.cp-when').delay(this.contactDelay).fadeIn(this.contactDelay);		
	});
	
	emailField.off('input').on('input', (e) => {
		//form will show/allow submitting once a valid email has been entered
		var emaildata = emailField.val();   
		var isvalidEmail = this.validateEmail(emaildata); 			
		if(isvalidEmail) {			
	    	if( submitButton.css('display') != 'block') {
	    		submitButton.delay(this.contactDelay).fadeIn(this.contactDelay);
	    	}
    	} else {
	    	if( submitButton.css('display') == 'block') {
	    		submitButton.fadeOut(this.contactDelayShort);
	    	}    		
    	}
	});	
	
	telephoneField.off('input').on('input', (e) => {
		//form will show/allow submitting once a telephone number has been entered
		var telephonedata = telephoneField.val();       			
		if((telephonedata.length>=7)&&(telephonedata.length<=18)) {			
	    	if( submitButton.css('display') != 'block') {
	    		submitButton.delay(this.contactDelay).fadeIn(this.contactDelay);
	    	}
    	}
	});	

	this.contactFormElement.keydown(function(event){
    	if(event.keyCode == 13 && !$(".input-textarea").is(":focus")) {
    		//preventing 'enter' from submitting form
      		event.preventDefault();
      		return false;
    	} else if ($(".input-textarea").is(":focus")) {
    		//forces textarea to autoexpand to fit text
    		var $focused = $(':focus');
    		$focused.css('height', $focused.prop('scrollHeight'));
    	}

  	});

};